import { registerApplication, start } from 'single-spa';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initSentry } from './common/observability/sentry';

/**
 * Error reporting is configured here because this is the module the bundle
 * actually starts from: `single-spa` only loads `./root.app` - and through it
 * `./App` - after `start()` below. Anything that throws before that point,
 * including the service-worker wiring in this file, is only reported if the
 * client already exists, so the call stays the first statement in the entry.
 *
 * It must also stay the only call. `initSentry()` is not idempotent, and a
 * second call would install a second client; a module body runs once per
 * page load, and single-spa remounts the application without re-evaluating
 * this file, so one top-level call covers every mount.
 */
initSentry();

registerApplication(
  'root',
  () => import('./root.app'),
  () => true
);

start();

serviceWorkerRegistration.getWaitingServiceWorker().then((registration) => {
  // eslint-disable-next-line no-use-before-define
  if (registration) displayReloadButton(registration);
});
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const registrationWaiting = registration.waiting;

    // eslint-disable-next-line no-use-before-define
    displayReloadButton(registrationWaiting);

    if (registrationWaiting) {
      registrationWaiting.addEventListener('statechange', (e) => {
        if (e.target.state === 'activated') {
          window.location.reload();
        }
      });
    }
  },
});

function displayReloadButton(registration) {
  const versionNotification = document.getElementById('version-notification');
  versionNotification.style.display = 'flex';

  const versionNotificationButton = document.getElementById(
    'version-notification-button'
  );

  versionNotificationButton.addEventListener('click', () => {
    if (registration) {
      registration.postMessage({ type: 'SKIP_WAITING' });
    }
  });
}
